import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tv-shows';
import TvShowCard from './TvShowCard';

export default function LatestSection() {
  const latestShows = tvShows.filter(s => s.isNew).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新上线
          </h2>
          <p className="text-sm text-foreground-500 mt-1">刚出炉的热门好剧，第一时间为你呈现</p>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 md:gap-5">
        {latestShows.map((show) => (
          <TvShowCard key={show.id} show={show} />
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}